import DataTableComponent from "./DataTableComponent";

export default DataTableComponent;
